const search = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M6.7 2.5a4.21 4.21 0 1 1 .02 8.42A4.21 4.21 0 0 1 6.7 2.5m0-1.5a5.71 5.71 0 1 0 5.71 5.7A5.7 5.7 0 0 0 6.7 1"/><polygon points="9.79966991 10.8603301 10.8603301 9.79966991 15.5303301 14.4696699 14.4696699 15.5303301"/></svg>',
};

export { search as default };
